export const HOME_ONLY = 1;
export const FACILITY_ONLY = 2;
export const HOME_AND_FACILITY = 3;
export const PHONE_ONLY = 4;
export const HOME_AND_PHONE = 5;
export const FACILITY_AND_PHONE = 6;
export const HOME_FACILITY_AND_PHONE = 7;
export const PURPOSE_RSV = 1;
export const PURPOSE_RSV_CANCEL = 2;
export const PURPOSE_RSV_CHANGE = 3;
export const RSV_FLAG_HOME = 0;
export const RSV_FLAG_FACILITY = 1;
export const RSV_FLAG_PHONE = 2;
export const INPUT_TYPE_TEXT = 1;
export const INPUT_TEXTAREA_FLAG = 2;
export const INPUT_DATE_FLAG = 3;
export const INPUT_EXP_FLAG = 4;
export const INPUT_RADIO_FLAG = 5;
export const INPUT_CHECK_FLAG = 6;
export const INPUT_SELECT_FLAG = 7;
export const INPUT_TELLNUM_FLAG = 8;
export const INPUT_MATHONLY_FLAG = 9;
export const INPUT_ENGMATH_FLAG = 10;
export const INPUT_URL_FLAG = 11;
export const INPUT_TYPE_NAME = 1001;
export const INPUT_TYPE_ADDRESS = 1002;
export const INPUT_TYPE_BIRTHDAY = 1003;
export const INPUT_TYPE_PHONE = 1004;
export const MAX_CHARACTER_LIMIT = 500;
export const CANCEL_ANNOUNCE="予約を終了する場合は、この画面を閉じてください。"
export const CANCEL_CHANGE_ANNOUNCE="予約変更を終了する場合は、この画面を閉じてください。"

// 利用場所設定のデフォルト文言（location_setting 未設定時のフォールバック）
export const DEFAULT_PLACE_SELECT_DESC = '利用場所を選択してください。';
export const DEFAULT_WEB_WINDOW_DESC = 'Web窓口を利用される場合は「自宅から利用する」を選択してください。';
export const DEFAULT_FACILITY_SELECT_DESC = '施設を訪問される場合は訪問する施設を選択してください。';
export const DEFAULT_CALL_SELECT_DESC = '通話による応答をご要望の場合は応答先を選択してください。';
export const DEFAULT_HOME_USE_LABEL = '自宅から利用する';

